import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledLogInAndEnrollStep = styled.div`
  height: 100%;
  .enroll-btn-teacher-name {
    color: ${Colors.orange} !important;
  }
  .enroll-btn-class-name {
    color: ${Colors.green} !important;
  }

  .no-user {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${Colors.backgroundPaleBlue};
    opacity: 0.85;
    width: 100%;
    padding: 10px 30px 20px 50px;
    height: 100%;
    border-radius: 6px;
    .no-user-message {
      text-align: center;
      font-size: 115%;
    }
    .back-btn {
      background-color: ${Colors.background};
    }
  }
`;
